import { createContext } from 'react'

import type { ViewportTypeValues } from '@hooks/useViewport/types'

const StandaloneViewportContext = createContext<ViewportTypeValues | undefined>(
  undefined,
)

export default StandaloneViewportContext
